/* jshint esversion: 6 */
import React from 'react';
import Modal from 'app/components/common/Modal.jsx';
import CCVersionModule from 'app/mixins/CCVersionModule.jsx';
import { FormattedDate } from 'react-intl';
import moment from 'moment';
import { compose } from 'redux';
import * as _ from 'underscore';
import AddOnWidget from 'app/components/Subscription/AddOnWidget.jsx';
import { Breakpoint } from 'react-socks';

class CCVersion15 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            version: 15,
            showCouponCode: false,
            applePayAvailable: window.ApplePaySession === undefined ? false : true,
            applePay: null,
            applePayButtonReady: false
        };

        this.toggleCoupon = this.toggleCoupon.bind(this);
        this.setApplePayTotal = this.setApplePayTotal.bind(this);
        this.getPercentDiscountPrice = this.getPercentDiscountPrice.bind(this);
        this.generatePrices = this.generatePrices.bind(this);
        this.payButton = React.createRef();

    }

    componentDidMount() {

        this.props.onMount(this.state.version);

    }

    componentDidUpdate(prevProps, prevState) {
        let applePay = null;
        const paymentActionSelector = () => {
            if (this.props.paymentType === 'applepay') {
                this.setApplePayTotal(applePay);
                applePay.begin();
            }
        }

        if (prevProps.couponCode === '' && this.props.couponCode !== '' && !this.state.showCouponCode) {
            this.setState({
                showCouponCode: true
            });
        }

        if (this.props.recurlyConfigured && !this.state.applePayButtonReady && this.props.paymentType === 'applepay') {
            if (this.payButton.current) {
                let applePayConfig = {
                    country: 'US',
                    currency: 'USD',
                    paymentRequest: {
                        recurringPaymentRequest: {
                            paymentDescription: `dlvr.it ${this.props.plans.details[this.props.plan].label}`,
                            regularBilling: {
                                type: "final",
                                paymentTiming: 'recurring',
                                label: `dlvr.it ${this.props.plans.details[this.props.plan].label}`
                            }
                        }
                    },
                    callbacks: {
                        onPaymentAuthorized: this.props.onApplePayPaymentAuthorized,
                    }
                }

                this.payButton.current.removeEventListener('click', this.props.onCheckout);

                applePay = recurly.ApplePay(applePayConfig);

                applePay.ready(() => {
                    if (this.payButton.current) {
                        this.payButton.current.addEventListener('click', paymentActionSelector);
                    }
                })

                applePay.on('error', (err) => {
                    // Actually a RecurlyError
                    // err.code, err.message
                    this.props.recurlyCallback(err);

                });

                applePay.on('cancel', () => {
                    this.setState({
                        applePayButonReady: false,
                    });
                    this.props.onApplePayCancel();
                })

                this.setState({
                    applePayButtonReady: true
                });
            }

        } else {
            if (this.payButton.current) {
                this.payButton.current.removeEventListener('click', paymentActionSelector);
                this.payButton.current.addEventListener('click', this.props.onCheckout);
            }
        }

    }

    toggleCoupon() {
        // don't allow the coupon code to be toggled if anything is in there
        if (this.props.couponCode !== '') {
            return;
        }

        this.setState({
            showCouponCode: this.state.showCouponCode ? false : true
        });

    }

    /*
     * The price with a percent coupon taken off, as Recurly takes it: the discount, rounded to the
     * nearest cent, comes off the price. Worked in whole cents, since 149.90 * 25% as a float is
     * just under 37.475 and would round the wrong way.
     */
    getPercentDiscountPrice(price, percent) {
        let cents = Math.round(price * 100),
            discount = Math.round(cents * percent / 100);

        return ((cents - discount) / 100).toFixed(2);

    }

    generatePrices() {
        let constants = this.props.app.config.constants,
            annualPrice = 0,
            monthlyPrice = 0;

        if (this.props.addOnPrices && this.props.addOns !== null && this.props.addOnPrices[constants.SUBSCRIPTION_ADDON_SOCIALS] !== undefined) {
            annualPrice = (this.props.prices[constants.SUBSCRIPTION_TERM_ANNUAL] + (this.props.addOnPrices[constants.SUBSCRIPTION_ADDON_SOCIALS][constants.SUBSCRIPTION_TERM_ANNUAL] * this.props.addOns)).toFixed(2);
            monthlyPrice = (this.props.prices[constants.SUBSCRIPTION_TERM_MONTHLY] + (this.props.addOnPrices[constants.SUBSCRIPTION_ADDON_SOCIALS][constants.SUBSCRIPTION_TERM_MONTHLY] * this.props.addOns)).toFixed(2);
        } else {
            annualPrice = this.props.prices[constants.SUBSCRIPTION_TERM_ANNUAL].toFixed(2);
            monthlyPrice = this.props.prices[constants.SUBSCRIPTION_TERM_MONTHLY].toFixed(2);
        }

        if (this.props.isValidCoupon) {

            let validatedCoupon = this.props.plans.validatedCoupon;

            if (!_.isEmpty(validatedCoupon)) {
                if (validatedCoupon.discount.type === 'percent') {
                    if (this.props.planTerm === constants.SUBSCRIPTION_TERM_MONTHLY) {
                        monthlyPrice = this.getPercentDiscountPrice(monthlyPrice, validatedCoupon.discount.percent);
                    } else if (this.props.planTerm === constants.SUBSCRIPTION_TERM_ANNUAL) {
                        annualPrice = this.getPercentDiscountPrice(annualPrice, validatedCoupon.discount.percent);
                    }

                } else if (validatedCoupon.discount.type === 'fixed') {
                    let fixedDiscount = validatedCoupon.discount.currencies[0].amount;

                    if (this.props.planTerm === constants.SUBSCRIPTION_TERM_MONTHLY) {
                        monthlyPrice = monthlyPrice - fixedDiscount;
                        monthlyPrice = monthlyPrice.toFixed(2);
                    } else if (this.props.planTerm === constants.SUBSCRIPTION_TERM_ANNUAL) {
                        annualPrice = annualPrice - fixedDiscount;
                        annualPrice = annualPrice.toFixed(2);
                    }


                }
            }

        }

        return {
            monthlyPrice,
            annualPrice
        };
    }

    setApplePayTotal(applePay) {
        let { monthlyPrice, annualPrice } = this.generatePrices(),
            constants = this.props.app.config.constants;

        if (this.props.planTerm === constants.SUBSCRIPTION_TERM_MONTHLY) {
            applePay._paymentRequest.total.amount = monthlyPrice;
            applePay._paymentRequest.recurringPaymentRequest.regularBilling.amount = monthlyPrice;
            applePay._paymentRequest.recurringPaymentRequest.regularBilling.recurrningPaymentStartDate = new Date();
            applePay._paymentRequest.recurringPaymentRequest.regularBilling.recurringPaymentIntervalUnit = "month";
            applePay._paymentRequest.recurringPaymentRequest.regularBilling.recurringPaymentIntervalCount = 1;
        } else {
            applePay._paymentRequest.total.amount = annualPrice;
            applePay._paymentRequest.recurringPaymentRequest.regularBilling.amount = annualPrice;
            applePay._paymentRequest.recurringPaymentRequest.regularBilling.recurrningPaymentStartDate = new Date();
            applePay._paymentRequest.recurringPaymentRequest.regularBilling.recurringPaymentIntervalUnit = "year";
            applePay._paymentRequest.recurringPaymentRequest.regularBilling.recurringPaymentIntervalCount = 1;
        }

    }

    render() {

        let content = null,
            // via window: Apple's SDK may not have loaded, and a bare ApplePaySession would throw
            canApplePay = window.ApplePaySession !== undefined && window.ApplePaySession.canMakePayments(),
            buttonLabel = this.props.buttonLabel,
            constants = this.props.app.config.constants,
            annualClass = 'cc-plan-info-cell annual term-chooser',
            monthlyClass = 'cc-plan-info-cell monthly term-chooser',
            planInfoBlock = null,
            totalBlock = null,
            trialLegalBlock = null,
            paymentTotalCopy = '',
            trialInfoBlock = null,
            trialEnd = 0,
            headerContent = null,
            planInfoClass = '',
            annualPrice = 0,
            monthlyPrice = 0,
            addOnLabel = '',
            savingsPct = 25,
            validatingCoupon = null,
            couponErrors = null,
            validatedCoupon = null,
            savingsElement = null,
            couponBlock = null,
            addOnControls = null;

        const generateAddOnWidgetLabel = (plan, quantity) => {
            let constants = this.props.app.config.constants,
                planQuantity = 0,
                baseQuantity = 0;

            if (!_.isEmpty(this.props.plans.details)) {
                baseQuantity = parseInt(this.props.plans.details[plan].limits.hardLimitOutputs);
                if (this.props.plans.details[plan].addOnQuantity[constants.SUBSCRIPTION_ADDON_SOCIALS] !== undefined) {
                    planQuantity = this.props.plans.details[plan].addOnQuantity[constants.SUBSCRIPTION_ADDON_SOCIALS].socials;
                }
                return (
                    <div>
                        <span className="number-display">{baseQuantity + (quantity * planQuantity)}</span> social accounts
                    </div>
                );
            }

            return '';
        };

        const updateAddOnQuantity = (plan, quantity) => {
            this.props.changeAddOns(plan, quantity);
        };

        // different savings for different plans
        if (this.props.plan === constants.PUB_LEVEL_6) {
            savingsPct = 33;
        } else if (this.props.plan === constants.PUB_LEVEL_15) {
            savingsPct = 18;
        } else if (this.props.plan === constants.PUB_LEVEL_16) {
            savingsPct = 17;
        }

        // create an element since all the percentages kinda go out the window
        // when a coupon is in play
        savingsElement = (
            <span className="cc-plan-savings"> - Save {savingsPct}% </span>
        );

        if (this.props.isValidCoupon) {
            validatedCoupon = this.props.plans.validatedCoupon;
        }

        headerContent = (
            <span>
                dlvr.it {this.props.planLabel}
            </span>
        );

        if (buttonLabel !== 'Processing') {
            //buttonLabel = `Unlock ${this.props.planLabel} Now`;
            buttonLabel = 'Get Started';
        }

        if (this.props.prices === null) {
            return null;
        }

        if (this.props.addOnPrices && this.props.addOns !== null && this.props.addOnPrices[constants.SUBSCRIPTION_ADDON_SOCIALS] !== undefined) {
            annualPrice = (this.props.prices[constants.SUBSCRIPTION_TERM_ANNUAL] + (this.props.addOnPrices[constants.SUBSCRIPTION_ADDON_SOCIALS][constants.SUBSCRIPTION_TERM_ANNUAL] * this.props.addOns)).toFixed(2);
            monthlyPrice = (this.props.prices[constants.SUBSCRIPTION_TERM_MONTHLY] + (this.props.addOnPrices[constants.SUBSCRIPTION_ADDON_SOCIALS][constants.SUBSCRIPTION_TERM_MONTHLY] * this.props.addOns)).toFixed(2);
        } else {
            annualPrice = this.props.prices[constants.SUBSCRIPTION_TERM_ANNUAL].toFixed(2);
            monthlyPrice = this.props.prices[constants.SUBSCRIPTION_TERM_MONTHLY].toFixed(2);
        }

        if (this.props.planTerm == constants.SUBSCRIPTION_TERM_ANNUAL) {
            annualClass += ' selected';
        } else {
            monthlyClass += ' selected';
        }

        if (this.props.isValidCoupon) {

            let validatedCoupon = this.props.plans.validatedCoupon;

            if (!_.isEmpty(validatedCoupon)) {
                if (validatedCoupon.discount.type === 'percent') {
                    if (this.props.planTerm === constants.SUBSCRIPTION_TERM_MONTHLY) {
                        monthlyPrice = this.getPercentDiscountPrice(monthlyPrice, validatedCoupon.discount.percent);
                        paymentTotalCopy = `Total: $${monthlyPrice}`;
                    } else if (this.props.planTerm === constants.SUBSCRIPTION_TERM_ANNUAL) {
                        annualPrice = this.getPercentDiscountPrice(annualPrice, validatedCoupon.discount.percent);
                        paymentTotalCopy = `Total: $${annualPrice}`;
                        savingsElement = null;
                    }
                    let unitLabel = '',
                        discountDuration = '';
                    if (validatedCoupon.discount.duration === "single_use") {
                        discountDuration = "1";
                        unitLabel = "month";
                        if (validatedCoupon.code === "intrial50") {
                            discountDuration = "your first month";
                            unitLabel = '';
                        }
                    } else {
                        unitLabel = validatedCoupon.discount.temporalUnit;
                         if (validatedCoupon.discount.temporalAmount > 1) {
                            unitLabel += "s";
                        }
                        discountDuration = validatedCoupon.discount.temporalAmount;
                    }

                    trialInfoBlock = (
                        <div className="plan-trial-price-detail v14">
                            {`Enjoy ${validatedCoupon.discount.percent}% off for ${discountDuration} ${unitLabel}`}
                        </div>
                    );
                } else if (validatedCoupon.discount.type === 'fixed') {
                    let fixedDiscount = validatedCoupon.discount.currencies[0].amount;

                    if (this.props.planTerm === constants.SUBSCRIPTION_TERM_MONTHLY) {
                        monthlyPrice = monthlyPrice - fixedDiscount;
                        monthlyPrice = monthlyPrice.toFixed(2);
                        paymentTotalCopy = `Total: $${monthlyPrice}`;
                    } else if (this.props.planTerm === constants.SUBSCRIPTION_TERM_ANNUAL) {
                        annualPrice = annualPrice - fixedDiscount;
                        annualPrice = annualPrice.toFixed(2);
                        paymentTotalCopy = `Total: $${annualPrice}`;
                        savingsElement = null;
                    }
                    // some special cases for specific codes
                    if (validatedCoupon.code === '99wow') {
                        trialInfoBlock = (
                            <div className="plan-trial-price-detail v14">
                                Get 5 months free - Our best price
                            </div>
                        );
                    } else {
                        trialInfoBlock = (
                            <div className="plan-trial-price-detail v14">
                                Lock in our best price
                            </div>
                        );
                    }

                } else {
                    paymentTotalCopy = 'Total: $0.00';
                    trialEnd = moment().add(validatedCoupon.freeTrialAmount, validatedCoupon.freeTrialUnit).format();
                    trialInfoBlock = (
                        <div className="plan-trial-price-detail v14">
                            Enjoy your completely FREE trial until <FormattedDate value={trialEnd} year='numeric' day='numeric' month='long' />
                        </div>
                    );
                }
            }

        } else {
            if (this.props.planTerm === constants.SUBSCRIPTION_TERM_MONTHLY) {
                paymentTotalCopy = `Total: $${monthlyPrice}`;
            } else if (this.props.planTerm === constants.SUBSCRIPTION_TERM_ANNUAL) {
                paymentTotalCopy = `Total: $${annualPrice}`;
            }
        }

        // special case where Charles would like to entice the user back to annual if possible
        if (!this.props.isValidCoupon && Object.keys(this.props.plans.validatedCoupon).length) {
            if (this.props.plans.validatedCoupon.code === '99wow') {
                trialInfoBlock = (
                    <div className="plan-trial-price-detail v14">
                        Choose annual - Get 5 months free
                    </div>
                );
            }
        }

        if (this.props.action === 'subscribe') {
            planInfoClass = 'cc-plan-info v15 ineligible';

            if ([constants.PUB_LEVEL_6, constants.PUB_LEVEL_8, constants.PUB_LEVEL_9, constants.PUB_LEVEL_10].indexOf(this.props.plan) !== -1) {
                let addOnQty = 0;

                if (this.props.addOns && this.props.addOns !== 0) {
                    addOnQty = this.props.addOns;
                    addOnLabel = "+ " + this.props.addOns;
                    if (this.props.addOns == 1) {
                        addOnLabel += " add-on";
                    } else {
                        addOnLabel += " add-ons";
                    }
                }

                addOnControls = (
                    <div className="add-on-widget-controls cc-modal">
                        <AddOnWidget
                            plan={this.props.plan}
                            term={this.props.planTerm}
                            addOns={addOnQty}
                            labelMaker={generateAddOnWidgetLabel}
                            onQuantityChange={updateAddOnQuantity}/>
                    </div>
                );
            }

            planInfoBlock = (
                <div className={planInfoClass}>
                    <div className={annualClass} data-context="modal" data-term={constants.SUBSCRIPTION_TERM_ANNUAL} onClick={this.props.changeTerm}>
                        <input type="radio" name="term" value={constants.SUBSCRIPTION_TERM_ANNUAL} data-term={constants.SUBSCRIPTION_TERM_ANNUAL} data-context="modal" onChange={this.props.changeTerm} checked={this.props.planTerm == constants.SUBSCRIPTION_TERM_ANNUAL} aria-label={`Annual, $${annualPrice} / year`}/> ${annualPrice} / year {savingsElement}
                    </div>
                    <div className={monthlyClass} data-context="modal" data-term={constants.SUBSCRIPTION_TERM_MONTHLY} onClick={this.props.changeTerm}>
                        <input type="radio" name="term" value={constants.SUBSCRIPTION_TERM_MONTHLY} data-term={constants.SUBSCRIPTION_TERM_MONTHLY} data-context="modal" onChange={this.props.changeTerm} checked={this.props.planTerm == constants.SUBSCRIPTION_TERM_MONTHLY} aria-label={`Monthly, $${monthlyPrice} / month`}/> ${monthlyPrice} / month
                    </div>
                </div>
            );
            totalBlock = (
                <div className="payment-total">
                    {paymentTotalCopy}
                </div>
            );
            trialLegalBlock = (
                <div className="disclaimer-block">
                    Not satisfied? <a href="https://support.dlvrit.com/hc/en-us/articles/40898354355739-14-day-money-back-guarantee" className="grey-link" target="_blank">Get a refund.</a>
                </div>
            )
        } else {
            planInfoBlock = (
                <div className="cc-plan-label center">Update your billing details</div>
            );
            buttonLabel = "Update";
        }

        if (this.props.isValidatingCoupon) {
            validatingCoupon = (
                <div className="validation-spinner">
                    <i className="fa fa-spinner fa-spin"></i>
                </div>
            );
        } else if (this.props.isValidCoupon !== null) {
            let feedbackIcon = (this.props.isValidCoupon) ? 'fa fa-check' : 'fa fa-times',
                feedbackWrapper = (this.props.isValidCoupon) ? 'feedback-icon valid' : 'feedback-icon invalid';

            validatingCoupon = (
                <div className={feedbackWrapper} onClick={this.props.resetCoupon}>
                    <i className={feedbackIcon}></i>
                </div>
            );

        }

        // unComment out coupon block 12/18/23
        if (this.props.action === 'subscribe') {
            if (this.props.couponError) {
                couponErrors = (
                    <div className="coupon-error">
                        {this.props.couponError}
                    </div>
                );
            }

            couponBlock = (
                <div className="coupon-block">
                    <div className="coupon-block-wrapper">
                        <div className="coupon-copy" onClick={this.toggleCoupon}>Have a promo code?</div>
                        {this.state.showCouponCode ? (
                            <div className="coupon-field-wrapper">
                                {validatingCoupon}
                                <input type="text"
                                    className="text-input medium"
                                    onChange={this.props.validateCoupon}
                                    placeholder="Enter Promo Code"
                                    value={this.props.couponCode}/>
                            </div>
                        ) : null}
                    </div>
                    {couponErrors}
                </div>
            );
        }

        content = (
            <div id="credit-card-modal" className="credit-card-modal v15">
                <div id="threeDS-challenge"></div>

                {planInfoBlock}
                {addOnControls}
                {trialInfoBlock}
                <form id="recurly-form" action="#" method="POST">
        			<div className="recurly-error">{this.props.recurlyMsg}</div>
                    <div className={`payment-form-wrapper ${this.props.action}`}>
                        <div className="payment-form clearfix">
                            <div className="input-group payment-type-selector clearfix">
                                <Breakpoint desktop only>
                                    <div>
                                        <div className="payment-type cc-selector">
                                            <div className="payment-radio">
                                                <input type="radio" name="payment" value={'card'} checked={this.props.paymentType === 'card'} onChange={this.props.changePaymentType} aria-label="Pay by card" />
                                            </div>
                                            <div className="card visa" onClick={this.props.changePaymentType} data-value='card' data-pw="pay-by-card"></div>
                                            <div className="card mastercard" onClick={this.props.changePaymentType} data-value='card'></div>
                                            <div className="card american_express" onClick={this.props.changePaymentType} data-value='card'></div>
                                            <div className="card discover" onClick={this.props.changePaymentType} data-value='card'></div>
                                        </div>
                                        <div className="payment-type paypal-selector">
                                            <div className="payment-radio">
                                                <input type="radio" name="payment" value={'paypal'} checked={this.props.paymentType === 'paypal'} onChange={this.props.changePaymentType} aria-label="Pay with PayPal" />
                                            </div>
                                            <div className="paypal-logo" onClick={this.props.changePaymentType} data-value='paypal' data-pw="pay-by-paypal"></div>
                                        </div>
                                        {canApplePay ? (
                                                <div className="payment-type applepay-selector">
                                                    <div className="payment-radio">
                                                        <input type="radio" name="payment" value={'applepay'} checked={this.props.paymentType === 'applepay'} onChange={this.props.changePaymentType} aria-label="Pay with Apple Pay" />
                                                    </div>
                                                    <div className="applepay-logo" onClick={this.props.changePaymentType} data-value='applepay' data-pw="pay-by-applepay"></div>
                                                </div>
                                            ) : null}
                                        {totalBlock}
                                    </div>
                                </Breakpoint>
                                <Breakpoint mobile only>
                                    <div>
                                        <div className="payment-type-mobile">
                                            <div className="payment-type cc-selector">
                                                <div className="payment-radio">
                                                    <input type="radio" name="payment" value={'card'} checked={this.props.paymentType === 'card'} onChange={this.props.changePaymentType} aria-label="Pay by card" />
                                                </div>
                                                <div className="card visa" onClick={this.props.changePaymentType} data-value='card' data-pw="pay-by-card"></div>
                                                <div className="card mastercard" onClick={this.props.changePaymentType} data-value='card'></div>
                                                <div className="card american_express" onClick={this.props.changePaymentType} data-value='card'></div>
                                            </div>
                                            <div className="payment-type paypal-selector">
                                                <div className="payment-radio">
                                                    <input type="radio" name="payment" value={'paypal'} checked={this.props.paymentType === 'paypal'} onChange={this.props.changePaymentType} aria-label="Pay with PayPal" />
                                                </div>
                                                <div className="paypal-logo" onClick={this.props.changePaymentType} data-value='paypal' data-pw="pay-by-paypal"></div>
                                            </div>
                                            {canApplePay ? (
                                                <div className="payment-type applepay-selector">
                                                    <div className="payment-radio">
                                                        <input type="radio" name="payment" value={'applepay'} checked={this.props.paymentType === 'applepay'} onChange={this.props.changePaymentType} aria-label="Pay with Apple Pay" />
                                                    </div>
                                                    <div className="applepay-logo" onClick={this.props.changePaymentType} data-value='applepay' data-pw="pay-by-applepay"></div>
                                                </div>
                                            ) : null}
                                        </div>
                                        {totalBlock}
                                    </div>
                                </Breakpoint>
                            </div>
                            {this.props.paymentBlock}
                        </div>
                        {couponBlock}
                    </div>
        			<div className="button-group clearfix">
                        <button ref={this.payButton} type="button" className={this.props.buttonClass} data-version={this.state.version}>
                            {buttonLabel}
                        </button>
        			</div>
                    {trialLegalBlock}
        		</form>
            </div>
        );

        let boxClass = 'v15';

        if (this.props.boxClass) {
            boxClass += ' ' + this.props.boxClass;
        }

        return (
            <Modal
                {...this.props}
                headerContent={headerContent}
                contentClass="cc-modal"
                content={content}
                boxClass={boxClass}
                close={this.props.closeAction}
                showClose={this.props.showClose}/>
        );

    }

};

CCVersion15.displayName = "CCVersion15";

const enhance = compose(
    CCVersionModule
);

export default enhance(CCVersion15);
